import type { UniclientAction } from '../action';
import type { PaymentDisclaimersProps, PaymentMethodProps } from '../payment';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

interface CurrentPaymentMethodProps {
  readonly title: string;
  readonly value: string;
}

export interface UpdatePaymentProps<TComponentAttributes extends string = string> extends UniclientBaseComponentProps {
  readonly currentPaymentMethod: CurrentPaymentMethodProps;
  readonly method: PaymentMethodProps<TComponentAttributes>;
  readonly action: UniclientAction;
  readonly disclaimers?: PaymentDisclaimersProps;
}

export type WizardUpdatePaymentProps<TComponentAttributes extends string = string> =
  UniclientWizardComponentBase<'update_payment'> & UpdatePaymentProps<TComponentAttributes>;

export function updatePayment<TAttribute extends string>(
  props: UpdatePaymentProps<TAttribute>,
): WizardUpdatePaymentProps<TAttribute> {
  return {
    ...props,
    type: 'update_payment',
  };
}
